import { memo } from "react";

import { Chart } from "primereact/chart";
import ChartDataLabels from 'chartjs-plugin-datalabels';

const options = {
    maintainAspectRatio: false,
    plugins: {
        datalabels: {
            align: 'end',
            anchor: 'end',
            formatter: (value, context) => {
                return Intl.NumberFormat('pt-BR').format(value)
            },
            font: {
                size: 20
            },
            color: "#2c3e50"
        },
        title: {
            display: true,
            text: 'Gráfico de Metragem',
            font: {
                size: 18
            }
        }
    },
}

export const SanfoGraficoTurma = memo(function SanfoGraficoTurma({ data }) {
    let values = [];
    let chartData = {}

    data.forEach((item) => {
        let index = values.findIndex((element) => {
            return element.label === item.turma;
        });

        if(index === -1) {
            values.push({
                label: item.turma,
                sum: item.dados[0].producao
            })
        }
    });


    let labels = [];
    let sums = [];

    values.forEach((item) => {
        labels.push(item.label);
        sums.push(item.sum);
    });

    chartData.datasets = [{ label: "(m) Total", data: sums, backgroundColor: "#3498db", borderColor: "#3498db" }]
    chartData.labels = labels;

    return (
        <div>
            <h4 className="p-m-1">Gráfico de Metragem Total por Turma</h4>
            <Chart
                id="chartMetragem"
                data={chartData}
                height={"350px"}
                width={"100%"}
                options={options}
                plugins={[ChartDataLabels]}
                type="bar"
            />
        </div>
    )
});